import { Pax } from 'gql/autogen/Pax';
import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';
import { PaxTypeCodeToIdMap } from 'core/utils/getPax';
import { QueryString } from 'core/utils/queryString/queryString';
import { SearchQueryKey } from 'core-framework/constant/SearchQueryKey';
import { getDateInYmdFormat } from 'core-framework/util/datetime/date';

export const getPaxQueryParam = (paxState: Pax[]) => {
    return paxState.map((pax) => `${PaxTypeCodeToIdMap[pax.code as PaxTypeCode] || -1}_${pax.quantity.value}`).join(',');
};

export const getLocationWithOfferQueryString = (locationSearch: string, enrichedOfferId: number, paxState: Pax[], offerOptionId: number, offerLevelSelectedDate: Date) => {
    const query = new QueryString(locationSearch);
    const paxQueryParam = getPaxQueryParam(paxState);
    query.set(SearchQueryKey.EnrichedOfferId, enrichedOfferId?.toString());
    query.set(SearchQueryKey.Pax, paxQueryParam);
    query.set(SearchQueryKey.OfferOptionId, offerOptionId.toString());
    query.set(SearchQueryKey.TravelDate, getDateInYmdFormat(offerLevelSelectedDate));

    return query;
};

export const getLocationWithOutOfferQueryString = (locationSearch: string) => {
    const query = new QueryString(locationSearch);
    query.delete(SearchQueryKey.EnrichedOfferId);
    query.delete(SearchQueryKey.Pax);
    query.delete(SearchQueryKey.OfferOptionId);

    return query;
};
